*, ::before, ::after {
	box-sizing: border-box;
	color: inherit;
	font-family: inherit;
	overflow-wrap: break-word;
}

@mixin visually-hidden {
	position: absolute     !important;
	height: 1px            !important;
	width:  1px            !important;
	white-space: nowrap    !important;
	overflow: hidden       !important;
	clip-path: inset(100%) !important;
	border: 0              !important;
	padding: 0             !important;
	margin: 0              !important;
	outline: none          !important;
}
.visually-hidden:not(:focus-visible) {
	@include visually-hidden;
}

[hidden] {
	display: none !important;
}

:disabled, .disabled {
	pointer-events: none;
	cursor: not-allowed;
	opacity: 0.8;
	filter: grayscale(0.4);
}

button {
	appearance: none;
	background: none;
	padding: 0;
	border: none;
	margin: 0;
	line-height: 1;
	text-decoration: none;
	cursor: pointer;
}

:host {
	display: contents;
}

#container {
	--shadow: 0 2px 4px hsl(0 0% 0% / 20%);
	position: relative;
	background-color: var(--nav-bg-color);
	box-shadow: var(--shadow);

	@include media-breakpoint-down(lg) {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		align-items: center;
		gap: 3em;
		height: 100px;
		padding-inline: 0;

		
		app-details#collapsable-menu::part(content) {
			padding-inline: var(--inline-page-margin);
		}

		[slot='open-icon'] {
			position: relative;

				&::after {
					position: absolute;
					content: '';
					top: -30px;
					left: -26px;
					width: 1px;
					height: 100px;
					background-color: #D9D9D9;
				}
		}

		[slot="open-icon"] {
			app-icon {
				width: 100%;
				height: rem(25);
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: rem(3);

				svg {
					fill: $primary;
					inline-size: rem(20);
				}
			}

			span {
				font-family: $font-family-secondary;
        		font-size: rem(12);
				line-height: rem(14.4);
        		font-weight: 400;
				color: $united-gray;
			}
		}


		app-details#collapsable-menu {
			@include media-breakpoint-down(lg) {
				&::part(collapsable-menu) {
					margin: 0 auto;
				}
			}
			&::part(collapsable-menu) {
				&.mobile-menu.login-open {
					&::part(toggle) {
						display: none;
					}
				}
			}
			&::part(summary),
			&::part(toggle) {
				max-width: fit-content;
				margin-left: auto;
				padding-right: 20px;
			}

			&::part(toggle) {
				display: grid;
				place-content: center;
				inline-size: 45px;
				block-size: 100%;
			}

			&::part(content) {
				position: absolute;
				inset-block-start: 100%;
				inset-inline: 0;
				box-shadow: inset var(--shadow);
				padding: 0;
				padding-inline: 0;
				transition: all 350ms;
				background: linear-gradient(to top, #f1f1f1 20%, $white);
				overflow-y: scroll;
				height: 100%;
			}

			& > app-icon svg {
				inline-size: 18px;
			}
		}
		@include media-breakpoint-down(lg) {

			.mobile-search-toggle {
				cursor: pointer;
	
				& > div {
					app-icon {
						width: 100%;
						height: rem(25);
						display: flex;
						align-items: center;
						justify-content: center;
						transform: translateY(3px);
	
						svg {
							fill: var(--nav-span-svg);
							aspect-ratio: 7 / 8;
						}
					}
	
					span {
						text-transform: uppercase;
						font-size: rem(12);
						font-weight: 500;
						letter-spacing: 0.025rem;
						color: var(--nav-span-svg);
					}
				}
	
				div + div {
					display: none;
				}
			}
	
			.mobile-search-box {
				position: absolute;
				width: 100%;
				left: 0;
				top: 0;
				background: $white;
			}
		}

		.close-opened-menu {
			position: relative;
			z-index: 2;
			display: flex;
			justify-content: flex-end;
			padding: 20px 24px 24px;
			width: 50%;
			margin-right: 0;
			margin-left: auto;
			cursor: pointer;
			margin-bottom: 85px;

			svg {
				fill: $primary;
				width: 20px;
				height: 20px;
			}
		}
	}

	@include media-breakpoint-up(lg) {
		#top-ribbon,
		#main-bar {
			padding-inline: 16px;
		}

		.container-fluid {
			position: relative;
			max-width: 1600px;
			margin: 0 auto;
		}

		#top-ribbon {
			background-color: #f1f1f1;
			border: 1px solid #D9D9D9;

			.container-fluid {
				display: flex;
				gap: 1em;
				padding-block: 7px;
				align-items: center;
				justify-content: end;

				& > div:first-child {
					flex-grow: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}
			}
		}

		#main-bar {

			slot[name='logo']::slotted(*) {
				margin-inline-end: auto;
			}

			.nav-elements {
				display: flex;
				align-items: center;
			}

			slot[name='button'] {
				display: block;
				margin-left: 24px;
				margin-top: -3px;
			}

			.container-fluid {
				display: flex;
				gap: 1em;
				min-height: 96px;
				align-items: center;
			}
		}
	}
	@include media-breakpoint-up(xl) {
		.container-fluid {
			width: calc(100% - 50px);
		}
	}
	@include media-breakpoint-up(xxl) {
		.container-fluid {
			width: calc(100% - 100px);
		}
	}
}